var React = require('react');

function IconDropbox (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"fill":"#1D1E22","fillRule":"evenodd","d":"M15.87 5.94l-7.83 5 7.83 5-7.83 5L.18 15.9l7.85-5L.18 5.94l7.85-5 7.84 5zM7.99 22.51l7.83-5 7.83 5-7.83 5-7.83-5zm15.7-11.62l-7.82 5 7.78 5.05 7.85-5-7.85-5 7.85-5-7.85-5-7.78 5 7.83 4.95z","clipRule":"evenodd","key":1})]);
}

IconDropbox.defaultProps = {"fill":"none","viewBox":"0 0 32 28"};

module.exports = IconDropbox;

IconDropbox.default = IconDropbox;
